export default class InitializeState {
  email = ''
  password = ''
  disabled = false
  initialized = false
}
